import React from 'react';
import MappingRow from './MappingRow';
import { ProjectRequestField } from '../../../services/formFeedsApi';

interface FieldMappingTableProps {
  projectRequestFields: ProjectRequestField[];
  formFields: Array<{ name: string; label: string; type: string }>;
  fieldMappings: Record<string, string>;
  onMappingChange: (projectFieldKey: string, formFieldName: string) => void;
}

const FieldMappingTable: React.FC<FieldMappingTableProps> = ({
  projectRequestFields,
  formFields,
  fieldMappings,
  onMappingChange,
}) => {
  return (
    <div className="min-w-full">
      <table className="w-full">
        <thead className="theme-bg-tertiary border-b theme-border sticky top-0 z-10">
          <tr>
            <th className="px-4 py-3 text-left text-sm font-semibold theme-text-primary w-1/2">
              Project Request Field
            </th>
            <th className="px-4 py-3 text-left text-sm font-semibold theme-text-primary w-1/2">
              Form Field
            </th>
          </tr>
        </thead>
        <tbody className="divide-y theme-border">
          {projectRequestFields.map((projectField) => (
            <MappingRow
              key={projectField.key}
              projectField={projectField}
              formFields={formFields}
              selectedFormField={fieldMappings[projectField.key] || ''}
              onMappingChange={onMappingChange}
            />
          ))}
        </tbody>
      </table>
      {projectRequestFields.length === 0 && (
        <div className="text-center py-12 theme-text-tertiary">
          <p>No fields available for mapping.</p>
        </div>
      )}
    </div>
  );
};

export default FieldMappingTable;
